(()=> {
  const header = document.querySelector('#shopify-section-header');
  if (!header) return;
  function updateHeaderHeight() {
    const root = document.querySelector(':root');
    root.style.setProperty('--header-height', `${header.clientHeight}px`);
  }

  console.log(header.clientHeight);
  updateHeaderHeight();
  const resizeObserver = new ResizeObserver((entries) => updateHeaderHeight());
  resizeObserver.observe(header);
  
})();